// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/**
 * The Work orders screen with this order open. `status=all` so a completed or
 * canceled order isn't filtered out of the list it is selected in. `site` is
 * the order's site: the screen switches the active site to it, since the order
 * is only found under its own site.
 *
 * Kept out of workOrderService so screens whose tests auto-mock the service
 * still get a real href.
 */
export function workOrderPath(siteId: string, workOrderId: string): string {
  const site = siteId ? `&site=${encodeURIComponent(siteId)}` : '';
  return `/work-orders?status=all${site}&wo=${encodeURIComponent(workOrderId)}`;
}
